export default "__VITE_ASSET__c3003ccb__"